import type { Theme } from '../../utilities/types';
import getImageSrc from '../../utilities/getImageSrc';
import ImagesFileNames from '../../images';

const mountainImage = getImageSrc(ImagesFileNames.bgMountainJpg);

export default (theme: Theme) => ({
  parentContainer: {
    minHeight: '100vh',
    height: '100%',
  },
  leftContainer: {
    padding: '2.5rem',
  },
  formControl: {
    marginTop: '1.5rem',
  },
  button: {
    marginBottom: '1.5rem',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  halfField: {
    width: '17.5rem',
  },
  mountainRight: {
    height: '100%',
    width: '100%',
    backgroundImage: `url(${mountainImage})`,
    backgroundColor: '#4583A1',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPositionX: '65%',
  },
});
